import { ElementRef, Injectable } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ValidationErrors } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class FormService {

  constructor(private formBuilder: FormBuilder) { }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.updateValueAndValidity({ emitEvent: true, onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  getValidationsMessages(form: FormGroup, formElement: ElementRef<any>): string[] {
    const validationMessageMessages: string[] = [];

    Object.keys(form.controls)?.forEach(key => {
      const controlErrors: ValidationErrors | null | undefined = form?.get(key)?.errors;
      if (controlErrors != null) {

        const labelElements = formElement.nativeElement?.querySelectorAll(`label[for='${key}']`);
        if (labelElements.length) {
          validationMessageMessages.push(`${labelElements[0].textContent}`);
        }

        Object.keys(controlErrors)?.forEach(keyError => {
          // console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
        });
      }
    });
    return validationMessageMessages;
  }

  getValidationsMessages2(form: FormGroup, formElement: ElementRef<any>): string[] {
    const validationMessages: string[] = [];

    const processControlErrors = (formGroup: FormGroup, parentElement: ElementRef<any>) => {
      Object.keys(formGroup.controls).forEach(key => {
        const control = formGroup.get(key);
        const controlErrors: ValidationErrors | null | undefined = control?.errors;

        if (controlErrors != null) {
          const labelElements = parentElement.nativeElement?.querySelectorAll(`label[for='${key}']`);
          if (labelElements.length) {
            validationMessages.push(`${labelElements[0].textContent}`);
          }

          Object.keys(controlErrors).forEach(keyError => {
            // console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
          });
        }

        // Verifica se o controle é um FormGroup aninhado e processa os erros
        if (control instanceof FormGroup) {
          const nestedElement = parentElement.nativeElement?.querySelector(`#${key}`);
          processControlErrors(control, new ElementRef(nestedElement || parentElement.nativeElement));
        }
      });
    };

    // Inicia o processamento do formulário principal
    processControlErrors(form, formElement);

    return validationMessages;
  }


  createValidationList(validationMessageMessages: string[]) {
    let message = '';
    validationMessageMessages.forEach(x => message += `<li>${x}</li>`);
    return `<br><ul class="validation-messages">${message}</ul>`;
  }

  validarForm(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        //control.markAsTouched({ onlySelf: true });
        control.updateValueAndValidity({ onlySelf: true, emitEvent: true })
      } else if (control instanceof FormGroup) {
        this.validarForm(control);
      }
    });
  }

  parseCurrency(val: any) {
    if (val) {
      return val.toString().split('R$ ').join('').split('.').join('');
    }

    return val;
  }
}
